const state = {
    localVersion: process.env.VUE_APP_LOCAL_VERSION,
    versionChecked: false,
    appOutOfDate : false
};

export default state;